"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = void 0;

var noop = function noop() {};

exports.noop = noop;